import React from "react";
import "./verkaufenSection.scss";
import ImageShow from "../../../../assets/images/provider.png";
import { NavLink } from "react-router-dom";
export default function VerkaufenSection() {
  return (
    <div>
      <div className="serkaufen-section-all-content-alignment">
        <div className="grid">
          <div className="grid-items">
            <div className="text-grid">
              <div className="text-grid-items">
                <div className="divider"></div>
              </div>
              <div className="text-grid-items">
                <h1
                  className="animate__slideInUp animate__animated wow"
                  data-wow-offset="100"
                >
                  Verkaufen Sie mit uns einzelne Einheiten oder ganze
                  Portfolios.
                </h1>
              </div>
            </div>
            <div className="text-style">
              <p
                className="animate__slideInUp animate__animated wow"
                data-wow-offset="100"
              >
                Bei Wohn-, Gewerbeimmobilien oder Grundstücken erarbeiten wir
                mit Ihnen ein kreatives und erfolgversprechendes
                Marketingkonzept. Interne und externe Spezialisten überlassen
                nichts dem Zufall. Konsequent verfolgen wir die definierten
                Ziele.
              </p>
              <p
                className="animate__slideInUp animate__animated wow"
                data-wow-offset="100"
              >
                Im Auftrag von internationalen und regionalen
                Immobilienportfolios suchen wir geeignete Immobilien.
              </p>
              <p className="bottom-text">Wir bringen Sie in Verbindung.</p>
              <div className="outline-primary-button">
                <NavLink to="/kontakt">
                  <button>Kontakt aufnehmen</button>
                </NavLink>
              </div>
            </div>
          </div>
          <div className="grid-items">
            <div className="image-style">
              <NavLink to="/kontakt">
                <img
                  className="animate__backInUp animate__animated wow"
                  data-wow-offset="100"
                  src={ImageShow}
                  alt="ImageShow"
                />
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
